export default "__VITE_ASSET__e45f2b64__"